import cn from 'clsx'
import { FC, PropsWithChildren } from 'react'

import { Icon, Typography } from '@/components/ui'

import { IButton } from './button.interface'

const Button: FC<PropsWithChildren<IButton>> = ({
	disabled,
	className,
	classNameText,
	size,
	icon,
	children,
	...props
}) => {
	const buttonClasses = cn(
		'rounded-[32px] z-10 p-2.5 w-fit transition-opacity duration-200 flex items-center justify-center text-white',
		size === 'xl' && 'py-2 px-9',
		className,
		disabled && 'opacity-20'
	)

	return (
		<button
			className={buttonClasses}
			disabled={disabled}
			type='button'
			aria-disabled={disabled}
			{...props}
		>
			{icon && (
				<Icon size={icon.size || 16} icon={icon.name} color={icon.color} />
			)}
			<Typography
				variant={size === 'xl' ? 'text-large' : 'text'}
				className={cn(classNameText, '!font-medium')}
			>
				{children}
			</Typography>
		</button>
	)
}

export default Button
